import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { AppConfig } from '../app.config';
import { UserService } from "../Services/user.service";
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [UserService]
})
export class ForgotPasswordComponent implements OnInit {
  // navToUrl: string = AppConfig.settings.apiServer.portalUrl;
  emailSent: boolean;
  userName: string;
 // emailFlag=false;
  emailNotExist: any = '';
  portalUrl: string = environment.main_url;
  constructor(private spinnerService: Ng4LoadingSpinnerService, private router: Router, private snackBar: MatSnackBar, private userService: UserService) {
    this.emailSent = false;
  }
  SendVerificationLink() {
    if (this.userName != "") {
      this.userService.SendVerificationLink(this.userName).subscribe(
        x => {
          if (x['Status']) {
            this.emailSent = true;
            this.emailNotExist = '';
          }
          else {
            this.emailSent = false;
            this.emailNotExist = "Email Address does not exist";
          }
        },
        error => {

        }
      );
    }
  }


  // OnHomeButtonClick() {
  //   this.router.navigate(["http://app.ccpdashboard.com:83/ccpiotportal/login"]);
  // }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/forgot-password/forgot-password.component.ts